import React from "react";

export default props => {
  return (
    <svg width="582px" height="128px" viewBox="0 0 582 128">
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        fillOpacity="0.5"
      >
        <g transform="translate(-794.000000, -936.000000)" fill="#FFFFFF">
          <g transform="translate(32.000000, 905.000000)">
            <g>
              <g transform="translate(388.000000, 0.000000)">
                <g transform="translate(0.000000, 28.000000)">
                  <g transform="translate(371.000000, 1.000000)">
                    <polygon
                      transform="translate(279.225536, 67.392629) rotate(-330.000000) translate(-279.225536, -67.392629) "
                      points="279.225536 76.1072262 270.623714 80.6294717 272.266515 71.051202 265.307495 64.2678338 274.924625 62.8703831 279.225536 54.1557855 283.526447 62.8703831 293.143576 64.2678338 286.184556 71.051202 287.827358 80.6294717"
                    />
                    <polygon
                      transform="translate(12.109771, 120.056366) rotate(-330.000000) translate(-12.109771, -120.056366) "
                      points="12.1097713 125.517108 6.7196967 128.350838 7.74910935 122.348902 3.38844741 118.098307 9.41473399 117.222636 12.1097713 111.761894 14.8048086 117.222636 20.8310952 118.098307 16.4704332 122.348902 17.4998459 128.350838"
                    />
                    <polygon
                      transform="translate(167.502066, 11.829764) rotate(-15.000000) translate(-167.502066, -11.829764) "
                      points="167.502066 18.1204185 161.292819 21.3848128 162.478679 14.4707147 157.455293 9.57412326 164.397442 8.56536994 167.502066 2.2747157 170.606689 8.56536994 177.548838 9.57412326 172.525452 14.4707147 173.711313 21.3848128"
                    />
                    <polygon
                      transform="translate(572.629187, 97.259891) rotate(-15.000000) translate(-572.629187, -97.259891) "
                      points="572.629187 105.333641 564.659919 109.523333 566.181914 100.649423 559.734641 94.3648853 568.644553 93.0701993 572.629187 84.9964494 576.613821 93.0701993 585.523733 94.3648853 579.07646 100.649423 580.598454 109.523333"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
